(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cavali-quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.getAttribute('data-ready') === '1') return;
      root.setAttribute('data-ready', '1');
      var products = {};
      try {
        JSON.parse(root.querySelector('[data-cv-quiz-data]').textContent || '[]').forEach(function (r) {
          var p = products[r.id] || (products[r.id] = { t: r.t, u: r.u, i: r.i, p: r.p, pf: r.pf, a: r.a, h: {} });
          p.h[r.h] = true;
        });
      } catch (e) {}
      var steps = root.querySelectorAll('[data-step]');
      var result = root.querySelector('[data-panel="result"]');
      if (!steps.length || !result) return;
      var limit = parseInt(root.getAttribute('data-limit'), 10) || 6;
      var collectionsUrl = root.getAttribute('data-collections-url') || '/collections';
      var answers = [];
      var current = 0;

      function show(i) {
        current = i;
        for (var k = 0; k < steps.length; k++) steps[k].hidden = k !== i;
        result.hidden = true;
      }

      function score(p) {
        var s = 0, n = 0;
        answers.forEach(function (a) {
          if (!a) return;
          var hasCol = a.h.length > 0, hasRange = a.min > 0 || a.max > 0;
          if (!hasCol && !hasRange) return;
          n++;
          var ok = true;
          if (hasCol) ok = a.h.some(function (h) { return p.h[h]; });
          if (ok && hasRange) ok = (!a.min || p.p >= a.min) && (!a.max || p.p <= a.max);
          if (ok) s++;
        });
        return { s: s, n: n };
      }

      function card(p) {
        var li = document.createElement('li');
        li.className = 'cv-card';
        var a = document.createElement('a');
        a.className = 'cv-plate cv-card__media';
        a.href = p.u;
        if (p.i) {
          var img = document.createElement('img');
          img.className = 'cv-cover';
          img.src = p.i;
          img.alt = p.t;
          img.loading = 'lazy';
          a.appendChild(img);
        }
        var info = document.createElement('div');
        info.className = 'cv-card__info';
        var h = document.createElement('h4');
        h.className = 'cv-card__title';
        var ha = document.createElement('a');
        ha.href = p.u;
        ha.textContent = p.t;
        h.appendChild(ha);
        var pr = document.createElement('p');
        pr.className = 'cv-card__price';
        pr.textContent = p.pf;
        info.appendChild(h);
        info.appendChild(pr);
        li.appendChild(a);
        li.appendChild(info);
        return li;
      }

      function showResult() {
        for (var k = 0; k < steps.length; k++) steps[k].hidden = true;
        var list = [], n = 0;
        Object.keys(products).forEach(function (id) {
          var r = score(products[id]);
          n = r.n;
          list.push({ p: products[id], s: r.s, k: list.length });
        });
        list.sort(function (a, b) { return (b.s - a.s) || (Number(b.p.a) - Number(a.p.a)) || (a.k - b.k); });
        var best = list.length ? list[0].s : 0;
        var shown = n && best > 0 ? list.filter(function (x) { return x.s > 0; }).slice(0, limit) : [];
        var grid = result.querySelector('[data-results]');
        grid.innerHTML = '';
        shown.forEach(function (x) { grid.appendChild(card(x.p)); });
        result.querySelector('[data-note]').hidden = !(shown.length && best < n);
        result.querySelector('[data-empty]').hidden = shown.length > 0;
        var picked = answers.filter(Boolean);
        var first = picked.map(function (a) { return a.h[0]; }).filter(Boolean)[0];
        var link = result.querySelector('[data-see-all]');
        if (first && link) link.href = collectionsUrl.replace(/\/$/, '') + '/' + first;
        var wa = result.querySelector('[data-wa]');
        if (wa) {
          var msg = (wa.getAttribute('data-msg') || '') + picked.map(function (a) { return a.label; }).join(', ');
          wa.href = (wa.getAttribute('data-base') || '') + encodeURIComponent(msg);
        }
        result.hidden = false;
        if (result.scrollIntoView) result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      root.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-opt]');
        if (opt) {
          var step = opt.closest('[data-step]');
          var idx = parseInt(step.getAttribute('data-step'), 10);
          step.querySelectorAll('[data-opt]').forEach(function (b) { b.setAttribute('aria-pressed', b === opt ? 'true' : 'false'); });
          answers[idx] = {
            h: (opt.getAttribute('data-h') || '').split(' ').filter(Boolean),
            min: parseFloat(opt.getAttribute('data-min')) || 0,
            max: parseFloat(opt.getAttribute('data-max')) || 0,
            label: opt.getAttribute('data-label') || ''
          };
          setTimeout(function () { if (idx < steps.length - 1) show(idx + 1); else showResult(); }, 220);
          return;
        }
        if (e.target.closest('[data-back]')) { show(Math.max(0, current - 1)); return; }
        if (e.target.closest('[data-restart]')) {
          answers = [];
          root.querySelectorAll('[data-opt]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          show(0);
          if (root.scrollIntoView) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    function initAll() { document.querySelectorAll('[data-cv-quiz]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cavali-tracking"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(form) {
      if (!form || form.getAttribute('data-ready') === '1') return;
      form.setAttribute('data-ready', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var guide = (form.querySelector('[data-guide]').value || '').trim();
        var err = form.querySelector('[data-error]');
        var hint = form.querySelector('[data-hint]');
        err.hidden = true;
        hint.hidden = true;
        var sel = form.querySelector('[data-carrier]');
        var opt = sel ? sel.options[sel.selectedIndex] : form.querySelector('input[name="carrier"]:checked');
        if (!opt || !opt.value) { err.textContent = err.getAttribute('data-carrier-msg') || ''; err.hidden = false; return; }
        if (!guide) { err.textContent = err.getAttribute('data-guide-msg') || ''; err.hidden = false; return; }
        var tpl = opt.getAttribute('data-tpl') || '';
        var tip = opt.getAttribute('data-tip') || '';
        var url = opt.value;
        if (tpl.indexOf('{guia}') > -1) {
          url = tpl.replace('{guia}', encodeURIComponent(guide));
        } else {
          try {
            navigator.clipboard.writeText(guide);
            hint.textContent = tip || hint.getAttribute('data-default') || '';
            hint.hidden = false;
          } catch (x) {}
        }
        if (url) window.open(url, '_blank', 'noopener');
      });
    }
    function initAll() { document.querySelectorAll('[data-cv-track]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
